module.exports = require("node:dgram");